import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  paragraph: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
}));

function KitchenAreasBox({ kitchenAreasNames }) {
  const classes = useStyles();
  return (
    <Box className={classes.paragraph} mb={6} mt={6}>
      {kitchenAreasNames?.map((name) => (
        <Box component="span" fontWeight="fontWeightMedium" key={`${name}`} mr={4}>
          {name}
        </Box>
      ))}
    </Box>
  );
}

KitchenAreasBox.propTypes = {
  kitchenAreasNames: PropTypes.array,
};

export default KitchenAreasBox;
